import store from "../store";

export default (to, from, next) => {
  if (store.getters.user && store.getters.user.admin) {
    next();
  } else {
    next({
      name: "Login",
      query: {
        redirect: to.fullPath
      }
    });
  }
};
